import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { useSelector } from "react-redux";

import { useLocalStorage } from "utils/hooks";
import { selectAllowPayments } from "store/users/selectors";

import Navigation from "features/Navigation";
import TopBar from "features/TopBar/container";
import InsightsTopBar from "features/Insights/InsightsTopBar";
import { InsightsProvider } from "features/Insights/InsightsContext";
import PaymentModal from "features/PaymentModal";
import TransactionHeader from "features/Transactions/components/TransactionHeader";

import classes from "./style.module.scss";

export default ({ children, history, user }) => {
    const location = useLocation();
    const allowPayments = useSelector(selectAllowPayments);

    const simplePaths = ["/login", "/register", "/create"];
    const barsActive = !!user && !simplePaths.some((path) => location.pathname.includes(path));
    const isDashboard =
        location.pathname === "" || location.pathname === "/" || location.pathname.includes("/dashboard");
    const isCommunityResults = location.pathname.includes("/communities") && location.pathname.includes("/results");
    const isUpgradeLibrary = location.pathname.includes("/upgrade-library");
    const isCreatePage = location.pathname.includes("/create");
    const isInsights = location.pathname.includes("/insights/");
    const isModelRoute = /^\/models\/[^/]+/.test(location.pathname);
    const isTransactions = location.pathname === "/user/transactions";

    const [isCollapsed, setIsCollapsed] = useLocalStorage("isCollapsed", false);
    const [isCollapsedDone, setIsCollapsedDone] = useState(isCollapsed);

    const content = (
        <>
            {barsActive && (
                <>
                    <TopBar history={history} allowPayments={allowPayments} />
                    {isInsights && <InsightsTopBar isCollapsed={isCollapsed} />}
                    <Navigation
                        history={history}
                        isCollapsed={isCollapsed}
                        isCollapsedDone={isCollapsedDone}
                        setIsCollapsed={setIsCollapsed}
                        setIsCollapsedDone={setIsCollapsedDone}
                    />
                    {isTransactions && <TransactionHeader isCollapsed={isCollapsed} />}
                </>
            )}
            <div
                className={classNames(classes.main, {
                    [classes.barsActive]: barsActive,
                    [classes.barsActiveCollapsed]: barsActive && isCollapsed && !isCreatePage,
                    [classes.isDashboard]: isDashboard,
                    [classes.isInsights]: isInsights,
                    [classes.isCommunityResults]: isCommunityResults,
                    [classes.isUpgradeLibrary]: isUpgradeLibrary,
                    [classes.isTransactions]: isTransactions,
                    [classes.isModel]: isModelRoute,
                })}
            >
                <div
                    className={`${classes.container} ${
                        location.pathname.includes("/parametric-analysis") ? classes.updatedContainer : ""
                    }`}
                >
                    {children}
                </div>
            </div>
            <PaymentModal allowPayments={allowPayments} />
        </>
    );

    if (isInsights) {
        return <InsightsProvider>{content}</InsightsProvider>;
    }

    return content;
};
